import { documentsAreaMessages } from '../../../messages';
import { Column } from '../../column';
import { DispositionDocument } from '../disposition';

export const dispositionColumns: Column<DispositionDocument>[] = [
  {
    headerLabel: documentsAreaMessages.titleLabelTable,
    key: 'title',
    type: 'react-node',
  },
  {
    headerLabel: documentsAreaMessages.practiceNumberLabelTable,
    key: 'practiceNumber',
    type: 'string',
  },
  {
    headerLabel: documentsAreaMessages.loadingDateLabelTable,
    key: 'uploadDate',
    type: 'date',
  },
  {
    headerLabel: documentsAreaMessages.signatureDateLabelTable,
    key: 'signDate',
    type: 'date',
  },
  {
    headerLabel: documentsAreaMessages.amountLabelTable,
    key: 'amount',
    type: 'amount',
  },
  {
    headerLabel: null,
    key: 'flagIsRead',
    type: 'react-node',
  },
];
